import { AsyncPicker, Button, describe, toast } from '@servicetim/ui/components';
import { UserRoundPlus } from 'lucide-react';
import { UserChip } from './badges';
import { RailCard, RailRow } from './rail-card';
import { useTicketContext } from './ticket-context';

/** Reporter, assignee picker (agent-safe lookup), organization. */
export function PeopleCard() {
  const { ticket, patch, patching, meId, loadUsers } = useTicketContext();

  const assign = async (assigneeId: string | null) => {
    if (assigneeId === ticket.assigneeId) return;
    try {
      const saved = await patch({ assigneeId });
      if (saved) toast.success(assigneeId ? 'Assigned' : 'Unassigned');
    } catch (e) {
      toast.error(describe(e).title);
    }
  };

  return (
    <RailCard title="People">
      <dl className="space-y-3">
        <RailRow label="Reporter">
          <UserChip name={ticket.display.reporter_id} emptyLabel="Unknown" />
        </RailRow>
        <RailRow label="Assignee">
          {ticket.canEdit ? (
            <div className="space-y-1.5">
              <AsyncPicker
                value={ticket.assigneeId}
                onChange={(id) => void assign(id ?? null)}
                load={loadUsers}
                displayLabel={ticket.display.assignee_id}
                placeholder="Unassigned"
                searchPlaceholder="Search people…"
                disabled={patching}
              />
              {ticket.assigneeId !== meId ? (
                <Button
                  size="sm"
                  variant="link"
                  className="h-auto p-0"
                  onClick={() => void assign(meId)}
                  disabled={patching}
                >
                  <UserRoundPlus />
                  Assign to me
                </Button>
              ) : null}
            </div>
          ) : (
            <UserChip name={ticket.display.assignee_id} />
          )}
        </RailRow>
        {ticket.organizationId ? (
          <RailRow label="Organization">{ticket.display.organization_id ?? '—'}</RailRow>
        ) : null}
      </dl>
    </RailCard>
  );
}
